import * as actions from './actions';

export const editState = (changes) => {
  return {
    type: actions.POR_EDIT_STATE,
    changes
  }
};


// WEBPACK FOOTER //
// ./src/store/actions/por.js